// extracted by mini-css-extract-plugin
export default {"buttonCustom":"ButtonCard_buttonCustom__nt9CG","rightIcon":"ButtonCard_rightIcon__E6U4h","text":"ButtonCard_text__4R9wd"};